"use client"

import { Button, Card, Col, Row } from "antd"
import FormSearchTours from "../tours/FormSearch"
import TourCategoryBreadcrumb from "./TourCategoryBreadcrumb"
import OtherCategories from "./OtherCategories"
import TopContent from "./TopContent"
import Tours from "./Tours"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useDevicePassedWidth } from "@/hooks/app/useDevicePassedWidth"
import { useParams } from "next/navigation"
import { useEffect, useMemo, useRef } from "react"
import { useToursCategories } from "@/hooks/tour/useToursCategories"
import { useAppDispatch } from "@/lib/redux/hooks"
import { tourActions } from "@/lib/redux/features/tour/reduce"
import PageFooterMobile from "../common/PageFooterMobile"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilter } from "@fortawesome/free-solid-svg-icons"
import PageDrawerMobile, { PageDrawerMobileRef } from "../common/PageDrawerMobile"
import { t } from "i18next"
import MKTScript from "../MKTScript"

const TourCategory = () => {
  const refFilterTours = useRef<PageDrawerMobileRef>(null)
  const isIPad = useDevicePassedWidth((width) => width >= 768 && width <= 1045)
  const isDesktop = useIsDesktop()
  const params = useParams()
  const dispatch = useAppDispatch()

  const { data: { tourCategories } } = useToursCategories()

  const selectedCategory = useMemo(() => {
    if (params?.categoryId && !!tourCategories?.length) {
      return tourCategories?.find(tourCategory => tourCategory.id === params?.categoryId)
    }
    return null
  }, [params?.categoryId, tourCategories?.length])

  useEffect(() => {
    if (!!selectedCategory) {
      dispatch(tourActions.selectTourCategory(selectedCategory))
    }
  }, [selectedCategory])

  return (
    <>
      <MKTScript />
      <Row justify="center">
        <Col span={24} className="tours-collection">
          {isDesktop && (
            <div className="tours-collection__search">
              <Card
                variant="borderless"
                size="small"
                className="home__searching--form home__searching--form--standalone"
              >
                <FormSearchTours enabledMobile={!isIPad} size={isIPad ? 'default' : 'small'} />
              </Card>
            </div>
          )}
          <div className="tour-category-page__header">
            <TourCategoryBreadcrumb />
            <TopContent />
          </div>
          <Row wrap={false} gutter={isDesktop ? [20, 0] : [0, 0]} className="tour-category-page__body">
            {isDesktop && (
              <Col flex="28rem" className="tour-category-page__sidebar">
                <OtherCategories />
              </Col>
            )}
            <Col flex={1} className="tour-category-page__list">
              <Tours />
            </Col>
          </Row>
        </Col>
      </Row>
      <PageDrawerMobile
        title={t("common.filter")}
        ref={refFilterTours}
        styles={{
          body: {
            padding: 0
          }
        }}
        headerProps={{
          shownRight: false,
          title: t("common.filter")
        }}
      >
        <Col span={24}>
          <OtherCategories
            onChange={() => refFilterTours.current?.close()}
          />
        </Col>
      </PageDrawerMobile>
      {!isDesktop && (
        <PageFooterMobile
        
        content={(
          <>
            <Col span={24}>
              <Button
                onClick={() => refFilterTours.current?.open()}
                type='text'
                block
                icon={<FontAwesomeIcon icon={faFilter} />}
              >
                {t("common.filter")}
              </Button>
            </Col>
          </>
        )}
      />)}
    </>
  )
}

export default TourCategory